import {lazy} from 'react';

export const WebinarDetailsLazy = lazy(() => import(/* webpackChunkName: "webinarDetails" */ '.'));
